import { encryptRequest, decryptResponse, produceAESKey } from "./cryptoHelper";
import { apiGet, apiPut } from "./apiClient";

const baseHeaders = { 'Content-Type': 'application/json' };

export const getNotificationsFromAPI = async (token, organization_name) => {
    const { aesKeyBase64, encryptedAESKey } = produceAESKey();

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        queryStringParameters: { encryptedKey: encryptedAESKey },
    };

    const response = await apiGet(`/notifications/${organization_name}`, requestInfo);
    return decryptResponse(response, aesKeyBase64);
};

export const readNotificationFromAPI = async (token, organization_name, notification_id) => {
    const { encryptedData, encryptedAESKey, aesKeyBase64 } = encryptRequest({ notification_id });

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        body: { encryptedData, encryptedAESKey },
    };

    const response = await apiPut(`/notifications/${organization_name}`, requestInfo);
    return decryptResponse(response, aesKeyBase64);
};
